import React from 'react';
import Support from './Support';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import { faEnvelope , faMoneyBill, faMoneyBillWave, faCalendarCheck} from '@fortawesome/free-solid-svg-icons'
import { faFacebook, faTwitter, faLinkedin, faDribbble, faInstagram, faPaypal, } from '@fortawesome/free-brands-svg-icons'
import WhatsApp from '@material-ui/icons/WhatsApp';
import Call from '@material-ui/icons/Call';
import Email from '@material-ui/icons/Email';

const CustomerSupport = (props) => {
    return (
        <div className='container p-1'>
             <div className=' container-3'>
            <Support {...props}></Support>
            <div className=" p-4" >
                <div className=''>
                <div className="bg-floralwhite p-2 ml border rounded-lg">
                 <Email></Email>  <label className="text-info h5 mt-3 " >info@cash4device.ca</label>
                   {/*<a onClick={ () => {window.location.href="/Support/CustomerSupport/SendTicket"}} ><span>send us an inquiry</span></a>*/}
                    <div className="col-md-12">
                        <label className='mt-2'>You'll get response in 24 hours</label>
                    </div>    
                </div>
                <div className="bg-floralwhite p-2 mt-2 border rounded-lg">
                   <Call></Call>   <label className="text-info h5 mt-3 "  >437-808-7032</label>
                    <div className="col-md-12">
                        <label>We're here from 10 AM - 5 PM EST</label>
                    </div>         
                </div>
                <div className="bg-floralwhite ml p-2 mt-2 border rounded-lg">                  
                    <WhatsApp/><a className="text-info h5 mt-3 ml-2" href="https://wa.me/4378087032?text=Hi%20I%20would%20like%20to%20chat%20with%20you" target='_blank'>   Chat with us on WhatsApp</a>
                    <div className="col-md-12">
                        <label className='mt-2'>We're available on Whats app from 10 am to 5 pm EST</label>
                    </div>  
                </div>
                </div>
               
               

                 <div className="mt-2">
                        <div className='border bg-floralwhite border-dark-white rounded-lg p-2 mb-5'>
                          <span style={{fontSize:19, fontWeight:700, textAlign:"left", margin:20}}>  How it works(Shipping label method): </span>
                          <div className='grid-container'>
                              <div style={{backgroundColor:"", borderStyle:"", marginTop:"10px", boxShadow:"3px 4px 2px gray"}} className='grid-item '>
                              <div style={{columnGap:"0.1rem", justifyContent:"center", }}className='d-flex  '> 
                              <div> <i class="fa fa-mobile fa-8x " style={{color:"", marginLeft:""}} ></i></div>
                              <div className="grid-container1 ml-2 ">
                              <i class="fa fa-check-square fa-2x"></i>
                              <i class="fa fa-check-square fa-2x"></i>
                              <i class="fa fa-check-square fa-2x"></i>
                              
                              </div>
                              
                              </div>
                               <div className='text-dark mb-2 mt-2 justify-content-center'>
                                
                                  <span  style={{fontSize:16, fontWeight:600, }}className=''>Provide the information needed for your device.</span>
                                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> We'll provide an instant offer on the basis of your provided information.</span>
                                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You accept the offer and complete the trasnaction by following the steps.</span>
                                
                                    
                                  </div>
                                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 1</button>
                              </div>
                                 
                              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                              <div style={{columnGap:"0.1rem", justifyContent:"center"}}className='d-flex '> 
                              <div><i class="fa fa-truck fa-6x" style={{color:"", marginLeft:""}} ></i></div>
                              </div>
                               <div className='ext-dark mb-2 mt-2 justify-content-center'>
                                    <span  style={{fontSize:16, fontWeight:600}}className='p-2'>We'll send you a prepaid shipping label right after the submission to your email.</span>
                                    <span  style={{fontSize:16, fontWeight:600, }}className=''>You will use provided shipping label to send your device(s) to us at no cost to you.</span>
                                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You can schedule pickup with carrier or drop it off yourself.</span>
                                 
                                  </div>
                                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 2</button>
                               </div>
                                
                                  
                              <div style={{backgroundColor:"floral-white",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                              <div className=''> 
                              <div> <FontAwesomeIcon icon={faMoneyBillWave} style={{fontSize:"100px"}}/></div>
                              </div>
                              <div className='text-dark mb-2 mt-2 justify-content-center'>
                                    <span  style={{fontSize:16, fontWeight:600}}className=''>Upon receiving device (s), we inspect the device (s) to validate the information provided by you on website.</span>
                                    <span  style={{fontSize:16, fontWeight:600, }}className=''> At the end of inspection, we process the payment immediately.</span>
                                    <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                                  </div>
                                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 3</button>
                               </div>
                                    
                            
                          </div> 
                        </div>
                        <div className='border bg-floralwhite border-dark-white rounded-lg p-2 mb-5'>
                          <span style={{fontSize:17, fontWeight:700, textAlign:"left", margin:20}}>  How it works(In person meeting method): </span>
                          <div className='grid-container'>
                              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item '>
                              <div style={{columnGap:"0.1rem", justifyContent:"center", }}className='d-flex  '> 
                              <div> <i class="fa fa-mobile fa-8x " style={{color:"", marginLeft:""}} ></i></div>
                              <div className="grid-container1 ml-2 ">
                              <i class="fa fa-check-square fa-2x"></i>
                              <i class="fa fa-check-square fa-2x"></i>
                              <i class="fa fa-check-square fa-2x"></i>
                              
                              </div>
                              
                              </div>
                               <div className='text-dark mb-2 mt-2 justify-content-center'>
                                
                                  <span  style={{fontSize:16, fontWeight:600, }}className=''>Provide the information needed for your device.</span>
                                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> We'll provide an instant offer on the basis of your provided information.</span>
                                  <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You accept the offer and complete the trasnaction by following the steps.</span>
                                
                                    
                                  </div>
                                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 1</button>
                              </div>
                                 
                              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                              <div style={{columnGap:"0.1rem", justifyContent:"center"}}className='d-flex '> 
                              <div><FontAwesomeIcon icon={faCalendarCheck} style={{fontSize:"100px"}}/></div>
                              </div>
                               <div className='ext-dark mb-2 mt-2 justify-content-center'>
                                    <span  style={{fontSize:16, fontWeight:600}}className='p-2'>Our assocciate will contanct you, to schedule an appointment with you as per your availability.</span>
                                    <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''>You will receive appointment cofirmation details on your email. </span>
                                    <span  style={{fontSize:16, fontWeight:600, }}className=''>You will meet our associate at your scheduled time and place.</span>
                                
                                 
                                  </div>
                                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 2</button>
                               </div>
                                
                                  
                              <div style={{backgroundColor:"",boxShadow:"3px 4px 2px gray"}} className='grid-item'>
                              <div className=''> 
                              <div> <FontAwesomeIcon icon={faMoneyBillWave} style={{fontSize:"100px"}}/></div>
                              </div>
                              <div className='text-dark mb-2 mt-2 justify-content-center'>
                                    <span  style={{fontSize:16, fontWeight:600}}className=''>Associate will inspect the device (s) on the spot and validate the information provided by you on website.</span>
                                    <span  style={{fontSize:16, fontWeight:600, }}className=''> At the end of inspection, we process the payment immediately.</span>
                                    <span  style={{fontSize:16, fontWeight:600, textAlign:"center"}}className=''> You get paid with the payment method of your choice like Cash, PayPal, E-trasfer(Interac).</span>
                                  </div>
                                  <button style={{fontSize:"20px", fontWeight:600}}className='border border-dark rounded-lg text-dark'>Step 3</button>
                               </div>
                                    
                            
                          </div> 
                        </div>
                        </div>
            </div>

        </div>
        </div>
       
    )
}

export default CustomerSupport;
